import React from "react";
import { Helmet } from "react-helmet-async";
import "./Clients.css";

const clients = [
  {
    name: "Daniel Sanders",
    company: "Sandezines",
    country: "USA",
    testimonial:
      "RK Overseas consistently delivers distinctive designs aligned with international market trends. Their product development and quality standards make them a reliable long-term sourcing partner.",
  },
  {
    name: "Michael Thompson",
    company: "AllStates",
    country: "USA",
    testimonial:
      "From concept to production, the experience with RK Overseas has always been seamless. Their innovation in blown glass and commitment to excellence truly set them apart.",
  },
  {
    name: "Emily Sullivan",
    company: "GlenHeaven",
    country: "USA",
    testimonial:
      "The versatility in design and consistent premium craftsmanship make RK Overseas a standout in the decorative glass industry. Their responsiveness and reliability are greatly appreciated.",
  },
  {
    name: "Andrew Collins",
    company: "Sullivans",
    country: "USA",
    testimonial:
      "RK Overseas offers beautifully crafted collections that combine modern styling with timeless appeal. Their attention to quality and detail makes them a valued partner season after season.",
  },
];

const Clients = () => {
  return (
    <div className="clients-page">
      <Helmet>
        <title>
          Our Clients | RK Overseas — Global Glass Exporter Firozabad, India
        </title>
        <meta
          name="description"
          content="RK Overseas, Firozabad, India serves clients across 30+ countries including USA, UK, Germany, Australia and UAE. Trusted global exporter of handcrafted glass decorative accessories since 1997."
        />
        <meta
          name="keywords"
          content="RK Overseas clients, glass exporter india clients, handcrafted glass wholesale buyers, glass decorative accessories international clients, firozabad glass exporter worldwide"
        />
        <link rel="canonical" href="https://rkoverseasindia.com/client" />
      </Helmet>

      <div className="page-banner">
        <h1>Our Clients</h1>
        <p className="breadcrumb">Home / Clients</p>
      </div>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Trusted By Clients Worldwide</h2>
          <div className="section-divider" />
          <p className="section-subtitle">
            We are proud to serve buyers and distributors from over 30 countries
            around the world.
          </p>

          <div className="clients__grid">
            {clients.map((client, i) => (
              <div className="clients__card" key={i}>
                <div className="clients__quote-icon">"</div>
                <p className="clients__testimonial">{client.testimonial}</p>
                <div className="clients__author">
                  <div className="clients__avatar">{client.name.charAt(0)}</div>
                  <div>
                    <span className="clients__name">{client.name}</span>
                    <span className="clients__company">
                      {client.company}, {client.country}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="section clients-map"
        style={{ background: "var(--cream)" }}
      >
        <div className="container">
          <h2 className="section-title">Our Global Presence</h2>
          <div className="section-divider" />
          <div className="clients-countries">
            {[
              "USA",
              "UK",
              "Germany",
              "France",
              "Argentina",
              "Australia",
              "Canada",
              "Japan",
              "UAE",
              "South Africa",
              "Denmark",
              "Netherlands",
            ].map((country, i) => (
              <span className="clients-country" key={i}>
                {country}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="section clients-gallery">
        <div className="container">
          <h2 className="section-title">Our Client Showcase</h2>
          <div className="section-divider" />
          <p className="section-subtitle">
            A glimpse of our collections showcased across international markets.
          </p>

          <div className="clients-gallery__grid">
            {[
              "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1772566675/Glenhaven-Home-Holiday-Logo-ReverseTM.jpg",
              "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1772567182/HOMETRENDS-NEW-LOGO-black-2.png",
              "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1772566970/GWDLogo-ohne-OHG-scaled.png",
            ].map((src, i) => (
              <div className="clients-gallery__card" key={i}>
                <img src={src} alt={`Client ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;
